module.exports = __webpack_public_path__ + "img/djyl-banner.93be7b33.jpg";